export const requestPending = (type) => `${type}_PENDING`;
export const requestSuccess = (type) => `${type}_SUCCESS`;
export const requestFail = (type) => `${type}_FAIL`;
